"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryReportForSchoolClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const sdk_constants_1 = require("../../constants/sdk.constants");
class SummaryReportForSchoolClient {
    static newInstance(options, retryOptions) {
        return new SummaryReportForSchoolClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions));
    }
    constructor(client) {
        this.client = client;
    }
    async assessmentsListBySchool(assessmentsListPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/assessments.listBySchool`, assessmentsListPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async assessmentsListBySchoolV2(assessmentsListPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/v2/assessments.listBySchool`, assessmentsListPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async assessmentsAverageScoreByItem(assessmentsAverageScoreByItemPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/assessments.scoreByItem`, assessmentsAverageScoreByItemPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async assessmentsAverageScoreByItemV2(assessmentsAverageScoreByItemPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/v2/assessments.scoreByItem`, assessmentsAverageScoreByItemPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async assessmentsScoreSummary(assessmentsScoreSummaryPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/assessments.scoreSummary`, assessmentsScoreSummaryPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async assessmentsScoreSummaryV2(assessmentsScoreSummaryPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/v2/assessments.scoreSummary`, assessmentsScoreSummaryPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async assessmentsAverageScoreBySchool(assessmentsAverageScoreBySchoolPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/assessments.scoreForSchool`, assessmentsAverageScoreBySchoolPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async assessmentsAverageScoreBySchoolV2(assessmentsAverageScoreBySchoolPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/v2/assessments.scoreForSchool`, assessmentsAverageScoreBySchoolPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async studentsDistributionBySchool(studentsScoreDistributionPerformancePayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/assessments.studentsDistributionBySchool`, studentsScoreDistributionPerformancePayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async studentsDistributionBySchoolV2(studentsScoreDistributionPerformancePayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/v2/assessments.studentsDistributionBySchool`, studentsScoreDistributionPerformancePayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async assessmentsSchoolListByAssessmentTemplate(assessmentTemplateId, headers, pageableOptions) {
        const response = await this.client.get(`${sdk_constants_1.AVR_API_PREFIX}/assessments.schoolList`, {
            headers,
            params: {
                assessmentTemplateId,
                ...pageableOptions,
            },
        });
        return response.body.data;
    }
}
exports.SummaryReportForSchoolClient = SummaryReportForSchoolClient;
//# sourceMappingURL=summary-report-for-school.client.js.map